
//供应商名称 联系人 类型电话 地址
const columnList: Array<column> = [
    {
        prop: "supplier_name",
        label: "供应商名称",
        width: 200,
    },
    {
        prop: "supplier_contacts",
        label: "联系人",
        width: 200,
    },
    {
        prop: "supplier_phone",
        label: "联系电话",
        width: 100,
    },
    {
        prop: "supplier_address",
        label: "地址",
        width: 200,
    },
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";

import {Request} from "@/api/request"
import {getPurchaseTable, getSupplierList, permissionList} from "@/api/http";
import { column } from "@/assets/types/common";

export default defineComponent({
    name: "frameworkManagement",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["供应商"]);
        let pageSize = ref(10),
            currentPage = ref(1),
			total = ref(0),
            tableData = ref([] as Array<any>),
			formRef = ref(null),
            roleList = ref({} as any),
			form_rules:any = {
				supplier_name: {required: true, message: '必填', trigger: 'change'},
			},
			form_load = ref(false),
            loading = ref(true),
            headClass = inject("headClass"),
            screenParameter: any = {
                page: currentPage.value,
                limit: pageSize.value,
                time_type: "",
                start_time: "",
                end_time: "",
                purchase_type: "",
                status: "",
                supplier_id: "",
                employee_id: "",
                search: "",
            },
            screen = ref({
                search: "",
                time: null,
                service: null,
            } as any),
			
            dialog_show = ref(false),
            dialog_title = ref(""),
            supplierList = ref([] as Array<any>),
			form = ref({} as any),
            form_default = ref({
                supplier_name: '',
				supplier_contacts: '',
				supplier_phone:'',
				supplier_mail: '',
				supplier_address: '',
				supplier_bankcard: '',
				supplier_accountname: '',
				supplier_branch: '',
				supplier_desc:''
            } as any),
			handleSizeChange = (size: number): void => {
				pageSize.value = size;
				getTableData();
			},
			handleCurrentChange = (page: number): void => {
				currentPage.value = page;
				getTableData();
			},
            getTableData = (): void => {
                loading.value = true;
                let mydata = {
                    type:1,
                    role_name:'purchase_supplier',
                };
                permissionList(mydata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
				Request.axiosInstance({
					url: "adminapi/supplier/list",
					data: {
						...screenParameter,
                        pagesize:pageSize.value,
						page:currentPage.value
					}
					
				}).then((res: any) => {
					let _list = res?.content?.list || []
					for(var i = 0; i < _list.length; i++)
						_list[i] = {..._list[i], status_bool: _list[i].status == 1}
						
					// total.value =
					loading.value = false;
					tableData.value = _list;
					total.value = res?.content?.total;
          total.value = res?.content?.total || 0;
                });
            },
            getsupplierList = (): void => {
                loading.value = true;
                getSupplierList({}).then((res: any) => {
                    supplierList.value = res?.content?.list || [];
                });
            },
            selectChange = (e: number): void => {
                getTableData();
            },
            searchChange = (e:string) => {
              if (!e){
                delete screenParameter["search"];
              } else {
                screenParameter["search"] = e;
              }
              getTableData();
            },
            screenChange = (
                e: string | Array<Date> | Array<number>,
                key: string
            ): void => {
                if (!e) {
                    if (key == "service") {
                        delete screenParameter["project_type_pid"];
                        delete screenParameter["project_id"];
                    } else if (key == "time") {
                        delete screenParameter["start_time"];
                        delete screenParameter["end_time"];
                    } else {
                        delete screenParameter[key];
                    }
                } else {
                    if (key == "service") {
                        screenParameter["project_type_pid"] = e[0];
                        screenParameter["project_id"] = e[1];
                    } else if (key == "time") {
                        screenParameter["start_time"] =
                            (e[0] as Date).getTime() / 1000;
                        screenParameter["end_time"] =
                            (e[1] as Date).getTime() / 1000;
                    } else {
                        screenParameter[key] = e;
                    }
                }
                getTableData();
            },
			_swich_change = (id: number) => {
				loading.value = true
				let _list = tableData.value
				let index = 0
				for(; index < _list.length; index++)
					if(_list[index].supplier_id == id) break;
				Request.axiosInstance({
					url: 'adminapi/supplier/upState',
					data: {
						supplier_id: id,
						status: _list[index].status == 0 ? 1: 0
					}
				}).then((res: any) => {
					loading.value = false
					tableData.value = _list
				})
			},
			_form_submit = () => {
				
				(formRef.value as any).validate((valid: boolean) => {
					if(!valid) return
					form_load.value = true
					Request.axiosInstance({
						url: dialog_title.value == '新增' ? "adminapi/supplier/create" : 'adminapi/supplier/edit',
						data: form.value
					}).then((res: any) => {
						form_load.value = false
						dialog_show.value = false
						getTableData()
					})
					
				})
				
			},
			_create = () => {
				form.value = {...form_default.value}
				dialog_title.value = '新增'
				form_load.value = false
				dialog_show.value = true
			},
			_editItem = (index: number) => {
				form.value = {...tableData.value[index] }
				dialog_title.value = '修改'
				form_load.value = false
				dialog_show.value = true
			}

        onMounted(() => {
            getTableData();
            getsupplierList();
        });

        return {
            columnList,
            tableData,
            loading,
            getsupplierList,
            supplierList,
            dialog_show,
            dialog_title,
            headClass,
            screen,
            screenChange,
            screenParameter,
            selectChange,
			_swich_change,
			handleSizeChange,
			handleCurrentChange,
			form_default,
			formRef,
			form_rules,
			_form_submit,
			form_load,
			form,
			_create,
			_editItem,
          searchChange,
          total,
            roleList,
            currentPage,
            pageSize
        };
    },
});
